module.exports = __webpack_public_path__ + "static/WEDDING E&M-497-63ec37e949dd145bf2fe48b35854a9e6.jpg";